import script from "./HeroCarouselItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./HeroCarouselItem.vue?vue&type=script&setup=true&lang=ts"

import "./HeroCarouselItem.vue?vue&type=style&index=0&id=48c798ee&lang=scss"

const __exports__ = script;

export default __exports__